import React from "react";
import logo from "../../../assets/newIcons/AYA.png";

function Logo({ isSidebar }) {
    return (
        <div className={`flex ${isSidebar ? 'flex-col' : 'flex'}  justify-center items-center `}>
            <img src={logo} alt="logo" className={`${isSidebar ? 'h-[8vh] duration-300 mb-4' : 'w-[50px] duration-300 '}`} />
            <div
                className={`${isSidebar ? 'hidden' : 'text-white text-[1rem]'
                    }   font-bold font-mmYein`}
            >
                Money Ball
            </div>
        </div>
    );
}

export default Logo;
